import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {map, tap} from 'rxjs/operators';

import {SessionService} from '@core';
import {BaseResult} from '@shared';

import {ProblemInstanceResult} from '../../models/problem-instance-result.model';

@Injectable({providedIn: 'root'})
export class ProblemInstanceService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);

    private problemInstance$: ReplaySubject<ProblemInstanceResult>;

    private readonly CacheSize = 1;

    public getProblemInstance(): Observable<ProblemInstanceResult> {
        if (!this.problemInstance$) {
            this.problemInstance$ = new ReplaySubject(this.CacheSize);
            this.requestProblemInstance()
                .pipe(
                    tap(result => {
                        const municipalityName = result.problemInstance?.officeInfo?.municipalityName;
                        if (municipalityName) {
                            this.sessionService.setMunicipalityName(municipalityName);
                        }
                    }))
                .subscribe(this.problemInstance$);
        }
        return this.problemInstance$.asObservable();
    }

    public rosterDepartmentIsPartOfInstance(): Observable<boolean> {
        return this.getProblemInstance()
            .pipe(
                map(result => result.problemInstance.rosterDepartments !== undefined
                    && result.problemInstance.rosterDepartments != null
                    && result.problemInstance.rosterDepartments.length > 0));
    }

    public requestProblemInstance(): Observable<ProblemInstanceResult> {
        const url = `${this.sessionService.getApiUrl()}/problem_instance/${this.sessionService.requestId}`;
        return this.httpClient.get<ProblemInstanceResult>(url);
    }

    public setPageId(pageId: number): Observable<BaseResult> {
        const url = `${this.sessionService.getApiUrl()}/set_page_id/${this.sessionService.requestId}/${pageId}`;
        return this.httpClient.put<BaseResult>(url, {});
    }
}
